"use strict";
var trunc = require("../internals/math-trunc");
module.exports = function(argument) {
  var number = +argument;
  return number !== number || number === 0 ? 0 : trunc(number);
};
